module.exports = __webpack_public_path__ + "assets/img/dzh-37.cdb29234.jpg";